import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OPTIMIZE_FEATURE_KEY } from './optimize.reducer';
import type { OptimizeState } from './optimize.model';

export const getOptimizeState = createFeatureSelector<OptimizeState>(OPTIMIZE_FEATURE_KEY);

export const getExperiment = (id: string) => createSelector(getOptimizeState, (state) => state.experiments[id]);
